export const company_name = "Tuxis";
